exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".white-box[data-v-184a8a30]{background-color:#fff;padding:20px;border-radius:10px;box-shadow:0 0 10px #d3d3d3;width:500px;margin:50px auto;position:relative}.logo[data-v-184a8a30]{position:absolute;top:10px;right:10px;width:20px;height:25px}.content[data-v-184a8a30]{display:flex;flex-direction:column;align-items:left;text-align:left}.small_head[data-v-184a8a30],.subtitle[data-v-184a8a30]{font-size:12px;font-weight:700;margin-bottom:8px}.value[data-v-184a8a30]{font-size:20px;margin-bottom:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/recover/ResetPassword.vue?vue&type=style&index=1&id=184a8a30&prod&scoped=true&lang=css&
// module id = 1523
// module chunks = 0